import cx from 'classnames';
import { Button, SimpleText } from 'platform-components';
import React from 'react';

export const LessonAssignmentDisabledButton = () => {
    return (
        <Button className={cx('side-panel__action-button', 'qa_lesson-assigned-button')} disabled>
            <SimpleText id="lessonModal.header.lessonAssigned" />
        </Button>
    );
};
